import { Injectable } from '@angular/core';
import { BaseService } from "../services";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { PaginationModel, RequestParamModel } from '../models';
import { CategoryModel } from '@coremodels';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private baseService: BaseService) {
  }

  // Get Lists
  getLists(requestParamModel: RequestParamModel): any {
    return this.baseService.get('category', requestParamModel)
      .pipe(map<any, any>(response => {
        const responseList = new PaginationModel<CategoryModel>();
        const headers = response.headers;
        responseList.setHeaders(headers);
        responseList.data = response.body.data as CategoryModel[];
        return responseList;
        }),
        catchError(err => throwError(() => err))
    );
  }

  // get details.
  getDetails(categoryID: number, requestParamModel?: RequestParamModel): Observable<CategoryModel> {
    return this.baseService.get('category/' + categoryID, requestParamModel)
      .pipe(map<any, CategoryModel>(response => {
        return response.body.data as CategoryModel;
        }),
        catchError(err => throwError(() => err))
    );
  }

  // Get product category Lists
  getProductCategoryList(requestParamModel: RequestParamModel, skipLoader: boolean = false): any {
    return this.baseService.get('product-category', requestParamModel, skipLoader)
      .pipe(map<any, any>(response => {
        const responseList = new PaginationModel<CategoryModel>();
        const headers = response.headers;
        responseList.setHeaders(headers);
        responseList.data = response.body.data as CategoryModel[];
        return responseList;
        }),
        catchError(err => throwError(() => err))
    );
  }

}
